import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "CourierDriverLicenses" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "select-none text-sm text-gray-400" }, " У курьера нет фотографий удостоверения ", -1)
const _hoisted_3 = { class: "mt-6 flex items-start justify-start" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col items-start"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400" }, "Фотографии удостоверения личности", -1)
const _hoisted_6 = ["alt", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_uploader = _resolveComponent("file-uploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.identificationCards.length === 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_file_uploader, {
              placeholder: "Загрузить",
              accept: "image/*",
              multiple: "",
              loading: _ctx.loading || _ctx.state.is_loading,
              disabled: _ctx.disabled,
              onChange: _ctx.onUploadFiles
            }, null, 8, ["loading", "disabled", "onChange"])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.identificationCards, (identification_card, i) => {
            return (_openBlock(), _createElementBlock("img", {
              class: "mt-2",
              key: identification_card.url,
              alt: `Фото удостоверения ${i + 1}`,
              src: identification_card.url
            }, null, 8, _hoisted_6))
          }), 128))
        ]))
  ]))
}